import { render, staticRenderFns } from "./partnerManagement.vue?vue&type=template&id=b4c7e720&scoped=true"
import script from "./partnerManagement.vue?vue&type=script&lang=js"
export * from "./partnerManagement.vue?vue&type=script&lang=js"
import style0 from "./partnerManagement.vue?vue&type=style&index=0&id=b4c7e720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c7e720",
  null
  
)

export default component.exports